import countriesStates from './countries-states-iso3166-slim.json'

type BaseCountry = (typeof countriesStates)[number]
type BaseState = BaseCountry['states'][number]

const unitedStatesStates = [
  ['AL', 'Alabama'],
  ['AK', 'Alaska'],
  ['AZ', 'Arizona'],
  ['AR', 'Arkansas'],
  ['CA', 'California'],
  ['CO', 'Colorado'],
  ['CT', 'Connecticut'],
  ['DE', 'Delaware'],
  ['DC', 'District of Columbia'],
  ['FL', 'Florida'],
  ['GA', 'Georgia'],
  ['HI', 'Hawaii'],
  ['ID', 'Idaho'],
  ['IL', 'Illinois'],
  ['IN', 'Indiana'],
  ['IA', 'Iowa'],
  ['KS', 'Kansas'],
  ['KY', 'Kentucky'],
  ['LA', 'Louisiana'],
  ['ME', 'Maine'],
  ['MD', 'Maryland'],
  ['MA', 'Massachusetts'],
  ['MI', 'Michigan'],
  ['MN', 'Minnesota'],
  ['MS', 'Mississippi'],
  ['MO', 'Missouri'],
  ['MT', 'Montana'],
  ['NE', 'Nebraska'],
  ['NV', 'Nevada'],
  ['NH', 'New Hampshire'],
  ['NJ', 'New Jersey'],
  ['NM', 'New Mexico'],
  ['NY', 'New York'],
  ['NC', 'North Carolina'],
  ['ND', 'North Dakota'],
  ['OH', 'Ohio'],
  ['OK', 'Oklahoma'],
  ['OR', 'Oregon'],
  ['PA', 'Pennsylvania'],
  ['RI', 'Rhode Island'],
  ['SC', 'South Carolina'],
  ['SD', 'South Dakota'],
  ['TN', 'Tennessee'],
  ['TX', 'Texas'],
  ['UT', 'Utah'],
  ['VT', 'Vermont'],
  ['VA', 'Virginia'],
  ['WA', 'Washington'],
  ['WV', 'West Virginia'],
  ['WI', 'Wisconsin'],
  ['WY', 'Wyoming'],
] as const

const unitedStatesEntry = {
  name: 'United States',
  iso2: 'US',
  emoji: '🇺🇸',
  states: unitedStatesStates.map(
    ([stateCode, name], index) =>
      ({
        id: 100000 + index,
        name,
        state_code: stateCode,
        latitude: '',
        longitude: '',
        type: 'state',
      } satisfies BaseState),
  ),
} satisfies BaseCountry

export const countriesStatesAugmented = countriesStates.some(
  (country) => country.iso2 === unitedStatesEntry.iso2,
)
  ? countriesStates
  : [...countriesStates, unitedStatesEntry]

export type CountryTypeAugmented = (typeof countriesStatesAugmented)[number]
export type StateTypeAugmented = CountryTypeAugmented['states'][number]
